export default {
  Region: 'us-east-1',
  UserPoolId: 'us-east-1_4sPvUbjSh',
  ClientId: '38c4v5e5r3g77q9r4h8qc2npot',
  IdentityPoolId: 'us-east-1:a491003a-1d9b-4c7b-9d61-36ecf5d4f637',
};



// WEBPACK FOOTER //
// ./src/config/cognito.js